import { render, staticRenderFns } from "./ProjectEmail.vue?vue&type=template&id=b90a3948&scoped=true&"
import script from "./ProjectEmail.vue?vue&type=script&lang=js&"
export * from "./ProjectEmail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEmail.vue?vue&type=style&index=0&id=b90a3948&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90a3948",
  null
  
)

export default component.exports